import React from "react";
import { PatientDocumentPOCItem, POCItemsDocumentAnswer } from "../../messages/PatientDocuments";
import { POCDocumentQuestionUI } from "./POCDocumentQuestionUI";
import { usePOCDocumentQuestion } from "./usePOCDocumentQuestion";

interface POCDocumentQuestionProps {
  questionId: number;
  questionText: string;
  currentAnswer: POCItemsDocumentAnswer[] | null;
  POCItems: PatientDocumentPOCItem[];
  isRequired: boolean;
  isValid: boolean;
  readonly: boolean;
  onClickWhileDisabled: () => void;
  onInsertAnswer: (id: number, answer: POCItemsDocumentAnswer[]) => void;
}

export function POCDocumentQuestion(props: POCDocumentQuestionProps) {
  const { handleTaskCheck, handleWhenToPerformChange, handleFrequencyChange, handleNotesChange } =
    usePOCDocumentQuestion({
      questionId: props.questionId,
      currentAnswer: props.currentAnswer,
      readonly: props.readonly,
      onClickWhileDisabled: props.onClickWhileDisabled,
      onInsertAnswer: props.onInsertAnswer,
    });

  return (
    <POCDocumentQuestionUI
      questionId={props.questionId}
      questionText={props.questionText}
      currentAnswer={props.currentAnswer}
      POCItems={props.POCItems}
      isRequired={props.isRequired}
      isValid={props.isValid}
      readonly={props.readonly}
      onTaskCheck={handleTaskCheck}
      onWhenToPerformChange={handleWhenToPerformChange}
      onFrequencyChange={handleFrequencyChange}
      onNotesChange={handleNotesChange}
    />
  );
}
